import axios from "axios";
import { API } from "@/lib/config";

const KEY = "cc_admin_session";

/** Admin API client: cookie + Bearer fallback (cross-site cookies are blocked by Safari when the site is on
 *  captains-cut.com and the backend on Emergent). */
export const adminApi = axios.create({ baseURL: API, withCredentials: true });
adminApi.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem(KEY);
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

export const saveAdminSession = (token) => localStorage.setItem(KEY, token);
export const clearAdminSession = () => localStorage.removeItem(KEY);
